/**
 * Whether a request goes to the platform's own API: the same origin as `apiUrl` and a path at or under its prefix.
 * Matching on whole URL parts rather than a substring keeps credentials and identity off any other host whose path
 * happens to contain the prefix, which a relative `apiUrl` such as `/api` would otherwise match.
 */
export function isManagedApiUrl(requestUrl: string, apiUrl: string, origin = globalThis.location?.origin): boolean {
  if (!origin && (!URL.canParse(requestUrl) || !URL.canParse(apiUrl))) return false;
  try {
    const request = new URL(requestUrl, origin);
    const api = new URL(apiUrl, origin);
    const prefix = api.pathname.replace(/\/+$/, '');
    return request.origin === api.origin && (request.pathname === prefix || request.pathname.startsWith(`${prefix}/`));
  } catch {
    return false;
  }
}
